"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferenceProvider = void 0;
const ramda_1 = require("ramda");
const provider_1 = require("./provider");
const utils_1 = require("./utils");
class ReferenceProvider extends provider_1.BaseProvider {
    static create(path) {
        return new ReferenceProvider({ path: parsePath(path) });
    }
    merge(props) {
        return new ReferenceProvider({ ...this.props, ...props });
    }
    async evaluate({ ctx }) {
        const path = (0, utils_1.resolvePath)(ctx.path, this.props.path || []);
        const value = (0, ramda_1.path)(path, ctx.root);
        return [path, value];
    }
    getPropsToLog() {
        return (0, ramda_1.dissoc)("path", this.props);
    }
}
exports.ReferenceProvider = ReferenceProvider;
function parsePath(path) {
    return path
        .split("/")
        .map(value => (/^[1-9]\d?$/.test(value) ? parseInt(value, 10) : value));
}
